import { getBaseUrl, isMagnoliaPreview } from './baseUrl';
import { getNationalProQueryParam } from './environmentService';
import { storeExpectedLoadingPageHeight } from './loadingPageHeight';
import { markReferralJustSubmitted } from './referralSubmissionFlag';
import { isSyntheticMonitor } from './syntheticMonitor';
import { markFormSubmittedForBfcacheReload } from './bfcacheReloadFlag';

function navigateToResultsPage(
  rfid: string,
  partnerUrn: string,
  url = getBaseUrl(),
  nationalProQueryParam = getNationalProQueryParam(partnerUrn),
  postalCode = '',
  {
    showLoadingPage = true,
    source
  }: { showLoadingPage?: boolean; source?: 'matcher' } = {}
) {
  const isNationalPro = nationalProQueryParam.length > 0;
  const queryParts: string[] = [`rfid=${rfid}`];
  if (nationalProQueryParam.length) queryParts.push(nationalProQueryParam);
  if (!isNationalPro && postalCode)
    queryParts.push(`postal_code=${encodeURIComponent(postalCode)}`);
  if (source) queryParts.push(`source=${source}`);

  // Forwarded from the current URL so a debug ?lock_loading_page=true
  // survives this redirect.
  const lockLoadingPage = new URLSearchParams(globalThis.location.search).get(
    'lock_loading_page'
  );
  if (lockLoadingPage) queryParts.push(`lock_loading_page=${lockLoadingPage}`);

  if (isSyntheticMonitor()) queryParts.push('synthetic_monitor=true');

  const queryString = '?' + queryParts.join('&');
  if (showLoadingPage) {
    markReferralJustSubmitted(rfid);
    storeExpectedLoadingPageHeight(rfid);
  }
  markFormSubmittedForBfcacheReload();

  // Under the local Magnolia preview, stay on localhost and hit its results route
  // instead of following the real page's /taxes/results path to the test environment
  // — that redirect exists only because there was previously no way to preview the
  // results page locally inside Magnolia.
  const destination = isMagnoliaPreview()
    ? `${globalThis.location.origin}/magnolia-wrapper/results`
    : `${url}/taxes/results`;
  globalThis.location.href = `${destination}${queryString}`;
}

export { navigateToResultsPage };
